import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-legacy-device-box',
  templateUrl: './legacy-device-box.component.html',
  styleUrls: ['./legacy-device-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegacyDeviceBoxComponent {}
